import React, { useEffect, useRef } from "react";
import { Result } from "antd";
import { useNavigate } from "react-router-dom";
import { ImpressumPage, LegalFooter, PrivacyPage } from "@dowty/legal";

export const AppLegalFooter: React.FC = () => {
    const navigate = useNavigate();
    const footerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const handleLegalNavigation = (event: MouseEvent) => {
            const target = event.target;
            if (!(target instanceof Element)) return;
            const anchor = target.closest<HTMLAnchorElement>(".dowty-legal-footer a[href]");
            if (!anchor || !footerRef.current?.contains(anchor) || anchor.origin !== window.location.origin) return;
            event.preventDefault();
            navigate(anchor.pathname + anchor.search + anchor.hash);
        };
        document.addEventListener("click", handleLegalNavigation);
        return () => document.removeEventListener("click", handleLegalNavigation);
    }, [navigate]);
    return <div className="sf-legal-footer" ref={footerRef}><LegalFooter links={{ impressum: "/impressum", privacy: "/datenschutz" }} /></div>;
};

export const AppLegalPage: React.FC<{ children: React.ReactNode }> = ({ children }) =>
    <div className="sf-page-content sf-public-page">{children}<AppLegalFooter /></div>;

export const LegalRoutePage: React.FC<{ page: "impressum" | "privacy" }> = ({ page }) =>
    <AppLegalPage>{page === "impressum" ? <ImpressumPage app="dowtex" /> : <PrivacyPage app="dowtex" />}</AppLegalPage>;

export const NotFoundPage: React.FC = () => <Result status="404" title={<h1 style={{ margin: 0 }}>Page not found</h1>} subTitle="This page isn’t available." />;
